import { getProducts } from "../../../Admin/State/Product/Action";
import { privateAxios } from "../../../config/apiConfig";
import { getAllProduct } from "../Product/Action";
import {
  CREATE_IMAGE_FAILURE,
  CREATE_IMAGE_REQUEST,
  DELETE_IMAGE_REQUEST,
  DELETE_IMAGE_FAILURE,
  UPDATE_IMAGE_REQUEST,
  UPDATE_IMAGE_FAILURE,
  DELETE_IMAGE_SUCCESS,
  UPDATE_IMAGE_SUCCESS,
  CREATE_IMAGE_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const createImage = (
  productId,
  isPrimary,
  productColorId,
  formData
) => async dispatch => {
  dispatch({ type: CREATE_IMAGE_REQUEST });
  try {
    const { data } = await privateAxios.post(
      `vendor/image/product/${productId}/${isPrimary}/product_color/${productColorId}`
    );
    if (data) {
      const {
        res
      } = await privateAxios.put(`vendor/image/${data.id}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success("image Uploaded Successfully");
      dispatch({ type: CREATE_IMAGE_SUCCESS, payload: data?.response });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_IMAGE_FAILURE, payload: error.message });
  }
};

export const updateImage = (imageId, isPrimary, productColorId, formData) => async dispatch => {
  dispatch({ type: UPDATE_IMAGE_REQUEST });
  try {
    const { data } = await privateAxios.put(`vendor/image/${imageId}/${isPrimary}/product_color/${productColorId}`);
    if (data.status === "SUCCESS" && imageId) {
      if (formData && formData.get("imageFile") && formData.get("imageFile").name) {
        const { res } = await privateAxios.put(
          `vendor/image/${data.response.id}/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
      }
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success("image Updated Successfully");
      dispatch({ type: UPDATE_IMAGE_SUCCESS, payload: data?.response });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({
      type: UPDATE_IMAGE_FAILURE,
      payload: error.message
    });
  }
};

export const deleteImage = (imageId) => async (dispatch) => {
  dispatch({ type: DELETE_IMAGE_REQUEST });
  try {
    const { data } = await privateAxios.delete(`vendor/image/${imageId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      dispatch(getProducts());
      toast.success(data.response);
      dispatch({ type: DELETE_IMAGE_SUCCESS, payload: data?.response });
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_IMAGE_FAILURE, payload: error.message });
  }
};
